// extracted by mini-css-extract-plugin
export var step = "StepToStep-module--step--3f6xx";
export var stepTitleTitle = "StepToStep-module--step-title-title--2jD_J";
export var stepNumber = "StepToStep-module--step-number--3JAny";
export var image = "StepToStep-module--image--128Em";
export var stepTitle = "StepToStep-module--stepTitle--10NnB";
export var odd = "StepToStep-module--odd--1i-iR";
export var stepText = "StepToStep-module--stepText--3DDPJ";
export var even = "StepToStep-module--even--Rgyoa";
export var spinAround = "StepToStep-module--spinAround--q7H3n";